import React from 'react'

import CurrencyInput from 'components/CurrencyInput'
import InputWithAppend from 'components/InputWithAppend'
import Select from './Select'
import StringInput from './StringInput'
import PercentageInput from "../../../../components/PercentageInput"

import {
  presenceErrorClass,
} from 'servos/formValidations'

class InputWithLabel extends React.Component {
  onChange = (value) => {
    this.props.onChange(value.replace(/\s/g, ""))
  }

  onSelectChange = (value) => {
    this.props.onChange(value)
  }

  renderInput() {
    const {
      type,
      defaultValue,
      errorMessage,
      options,
      borderStyle,
      size,
    } = this.props;

    switch(type) {
      case 'append':
        return(
          <InputWithAppend
            defaultValue={ defaultValue }
            onChange={ this.onChange }
            errorMessage={ errorMessage }
            appendText={ '%' }
            size={ size }
          >
            {this.props.children}
          </InputWithAppend>
        )
      case 'percentage':
        return (
          <PercentageInput
            defaultValue={defaultValue}
            onChange={this.onChange}
            errorMessage={errorMessage}
            size={size}
          >
            {this.props.children}
          </PercentageInput>
        )
      case 'currency':
        return(
          <CurrencyInput
            defaultValue={ defaultValue }
            onChange={ this.onChange }
            errorMessage={ errorMessage }
            size={ size }
          >
            {this.props.children}
          </CurrencyInput>
        )
      case 'select':
        return(
          <Select
            defaultValue={ defaultValue || '' }
            errorMessage={ errorMessage }
            onChange={ this.onSelectChange }
            borderStyle={ borderStyle }
            options={ options }
          />
        )
      case 'numberOnly':
        return(
          <StringInput
            numberOnly={true}
            defaultValue={ defaultValue }
            onChange={ this.onChange }
            errorMessage={ errorMessage }
          />
        )
      default:
        return(
          <StringInput
            numberOnly={false}
            defaultValue={ defaultValue }
            onChange={ this.onChange }
            errorMessage={ errorMessage }
          />
        )
    }
  }

  render() {
    const {
      label,
      errorMessage,
    } = this.props;

    return(
      <div className={ `form-group ${presenceErrorClass(errorMessage)}` }>
        <label>{ label }</label>
        { this.renderInput() }
      </div>
    )
  }
}

export default InputWithLabel;
